import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { ServicesContext } from '~/services';

interface MfaVerifyProps {
    submitAction: (x: boolean) => void;
}
export function MfaVerify({ submitAction }: MfaVerifyProps) {
    const servicesContext = React.useContext(ServicesContext);
    const location = useLocation<{ from: { pathname: string } }>();
    const history = useHistory();
    const [mfacode, setMfacode] = React.useState('');
    const [trusted, setTrusted] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    async function handleSubmit() {
        try {
            setLoading(true);
            await servicesContext.user.mfaVerify(trusted, mfacode);
            const { from } = location.state || { from: { pathname: '/dashboard' } };
            history.push(from.pathname);
            setLoading(false);
        } catch (e) {
            setError(e.message);
            setLoading(false);
        }
    }

    return (
        <Form onSubmit={handleSubmit} values={{ mfacode, trusted }}>
            <FormGroup htmlFor="mfacode" className="mb-3">
                <div className="col-12">
                    <input
                        type="text"
                        required
                        className="form-control"
                        id="mfacode"
                        placeholder="Enter verification code"
                        value={mfacode}
                        onChange={(e) => setMfacode(e.target.value)}
                    />
                </div>
                <ValidationMessage type="required" className="col-12 text-center mt-3">
                    Please enter the verification code.
                </ValidationMessage>
            </FormGroup>
            {servicesContext.user.hasFeatureToggle('trusted_computer') && (
                <>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="trusted"
                            value={trusted ? 1 : 0}
                            onChange={(e) => setTrusted(e.target.checked)}
                        />
                        <label htmlFor="trusted" className="form-check-label">
                            Trust this computer
                        </label>
                    </div>
                    <div className="form-check mt-1">
                        We won&apos;t ask you to verify your account with codes for this browser on
                        this computer for the next 30 days.
                    </div>
                </>
            )}
            <div className="row mt-3">
                <div className="col text-end">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Verify Code
                    </button>
                </div>
            </div>
            {error && (
                <div className="row mt-3">
                    <div className="col-10 offset-1 text-center">
                        {error}
                        <br />
                        <br />
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => submitAction(false)}
                        >
                            Return
                        </button>
                    </div>
                </div>
            )}
        </Form>
    );
}
